import { CollectionTransformer } from '@/transformers/index'
import TimelineBlock from '@/models/TimelineBlock'
import { AddressTransformer } from '@/transformers/AddressTransformer'

export class TimelineBlockTransformer {
    constructor (
        collectionTransformer = new CollectionTransformer(),
        addressTransformer = new AddressTransformer()
    ) {
        this.collectionTransformer = collectionTransformer
        this.addressTransformer = addressTransformer
    }

    transform (data) {
        return new TimelineBlock(
            data.status,
            data.startTime,
            data.endTime,
            this.addressTransformer.transform(data.startAddress),
            this.addressTransformer.transform(data.endAddress),
            data.deviceId,
            data.journeyId,
            data.journeyType
        )
    }
}
